import { Menu } from 'primeng/menu';
import { Option } from '../../../../../ui-components/core-dropdown/core-dropdown.component';

export interface ICaseSidebar {
  key: string;
  label: string;
  icon: string;
  description: string;
  bgColor: string;
  changed?: boolean;
}

export type ICaseTabAction = MenuAction | ClickAction | SimpleAction;
export type MenuAction = {
  kind: 'menu';
  label: string;
  icon?: string;
  color?: string;
  action: (p: { event: MouseEvent; menu: Menu; data: any }) => void;
};

export type ClickAction = {
  kind: 'click';
  label: string;
  icon?: string;
  color?: string;
  action: (p: { event: MouseEvent }) => void;
};

export type SimpleAction = {
  kind: 'simple';
  label: string;
  icon?: string;
  color?: string;
  action: () => void;
};

export interface IServiceInformationItem {
  serviceCode: string;
  serviceName: string;
  serviceId: number;
  gatePrice: {
    price: number | null;
    originalPrice: number | null;
    icon: string | null;
    currency: string | null;
    priceId: number | null;
    isFlexiblePrice: boolean | null;
    givenForFree: boolean | null;
  } | null;
  memberPrice: {
    price: number | null;
    currency: string | null;
    icon: string | null;
    originalPrice: number | null;
    priceId: number | null;
    isFlexiblePrice: boolean | null;
    givenForFree: boolean | null;
  } | null;
  quantity: number;
  totalPrice: number;
  unitPrice: number;
  lastPrice: number;
  priceType: 'gatePrice' | 'memberPrice' | null;
  discount: {
    percentage: number | null;
    price: number | null;
  };
  bottomDiscount: {
    percentage: number | null;
    price: number | null;
    description: string | null;
  };
  provision: {
    percentage: number | null;
    price: number | null;
  };
  flexiblePrice: {
    isFlexible: boolean;
    price: number | null;
  };
  givenForFree: boolean;
  expanded?: boolean;
  ruleOfPopups: ICaseRowRule;
}

export interface ICaseRowRule {
  rowDiscount: boolean;
  bottomDiscount: boolean;
  provision: boolean;
  flexiblePrice: boolean;
  firstProcess: 'row' | 'bottom' | 'provision' | 'flexible' | null;
}
export interface IServiceInformation {
  services: IServiceInformationItem[];
  numberOfServices: number | null;
  provisionNo: string | null;
  provisionInstitution: number | null;
  provisionDescription: string | null;
  totalPrice: number | null;
  totalProvisionPrice: number | null;
  totalDiscountPrice: number | null;
  bottomDiscountPrice: number | null;
  bottomDiscountDescription: string | null;
  lastPrice: number | null;
  
}

export enum CaseTabKey {
  SAVE = 'SAVE',
  CANCEL = 'CANCEL',
  PRINT = 'PRINT',
  COMPLETE = 'COMPLETE',
  APPROVE = 'APPROVE',
  UNAPPROVE = 'UNAPPROVE',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  SERVICE = 'SERVICE',
  NOTE = 'NOTE',
  DOCUMENT = 'DOCUMENT',
  SCHEDULE = 'SCHEDULE',
  TRACK_VEHICLE = 'TRACK_VEHICLE',
  HISTORY = 'HISTORY',
  MOVE = 'MOVE',
  ASSIGN_VEHICLE = 'ASSIGN_VEHICLE',
  ASSIGN_STAFF = 'ASSIGN_STAFF',
  TITLE = 'TITLE',
  CASE_FEATURES = 'CASE_FEATURES',
  SURVEYS = 'SURVEYS',
  ACTIONS= 'ACTIONS'
}
export interface INewCasePayment {
  id: number | null;
  paymentType: number | null;
  paymentDate: Date | null;
  institution: number | null;
  provisionNo: string | null;
  staff: number | null;
  exchangeType: number | null;
  total: number | null;
  rateOfExchange: number | null;
  totalTL: number | null;
}

export interface ICasePayment {
  id: number;
  paymentType: Option | null;
  paymentDate: Date;
  institution: Option | null;
  provisionNo: string | null;
  staff: Option | null;
  exchangeType: Option | null;
  total: number | null;
  rateOfExchange: number | null;
  totalTL: number | null;
  uuid: string | null;
  payed: boolean | null;
  sipayStatus: string | null;
  sipaySmsSended: boolean;
}

export interface ICaseStatusLogs {
  vehicleId: number;
  vehicleNo: string;
  vehiclePlate: string;
  dot: { id: number; dotName: string };
  statusHistory: ICaseStatusHistory[];
}

export interface ICaseStatusHistory {
  id: number;
  statusName: string;
  statusSla?: number;
  statusStartDate: Date;
  statusEndDate?: Date;
  statusDuration: number;
  createdAt: Date;
  createdBy: string;
  statusStartLatitude?: string;
  statusStartLongitude?: string;
  statusEndLatitude?: string;
  statusEndLongitude?: string;
  location?: string;
  icon?: string;
}

export interface ICaseVehicleDuration {
  isMainVehicle: boolean;
  callDate: Date;
  ongoingDate: Date;
  arriveDate: Date;
  caseEndDate: Date;
}


export enum PaymentReceiverEnum {
  PERSON = 'PERSON',
  INSTITUTION = 'INSTITUTION',
}

export interface CasePaymentReceiver {
  id?:number;
  type: PaymentReceiverEnum.PERSON;
  patientNo: number | null;
  tckn: string | null;
  fullName: string | null;
  institutionNo?: number | null;
  institutionName?: string | null;
  taxOffice?: string | null;
  taxNo?: string | null;
  phone: string | null;
  email: string | null;
  address: string | null;
  patient?:any;
  institution?:any;
  saveInstitution?:boolean | false;
}
